<template>
    <el-table
            :data="propsTableData"
            style="width: 100%"
            class="table-wrap remote-table-wrap">
        <el-table-column
                prop="hasAtta"
                width="30"
                align="center">
            <template slot-scope="scope">
                <span v-show="scope.row.hasAtta==true" >
                            <svg class="icon" aria-hidden="true" style="font-size:24px;color:#888888;">
                                <use xlink:href="#icon-biaoqianshuqianhuixingzhen"></use>
                            </svg>
                </span>
                <span v-show="scope.row.hasAtta==false"></span>
            </template>
        </el-table-column>
        <!--<el-table-column-->
                <!--prop="consultGroupNo"-->
                <!--label="编号"-->
                <!--align="center"-->
                <!--class="table-column"-->
                <!--show-overflow-tooltip>-->
        <!--</el-table-column>-->
        <el-table-column
                prop="consulterName"
                label="患者"
                class="table-column"
                align="center"
                width="75">
        </el-table-column>
        <!--<el-table-column-->
                <!--prop="consulterGender"-->
                <!--label="性别"-->
                <!--:formatter="sexSelect"-->
                <!--class="table-column"-->
                <!--width="60"-->
                <!--align="center">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
                <!--prop="consulterAge"-->
                <!--label="年龄"-->
                <!--class="table-column"-->
                <!--align="center"-->
                <!--width="60">-->
        <!--</el-table-column>-->
        <el-table-column
                prop="consulterMobile"
                label="联系方式"
                align="center"
                class="table-column"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="initHosName"
                label="申请机构"
                align="center"
                class="table-column"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="initDeptName"
                label="申请科室"
                align="center"
                class="table-column"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="initDocName"
                label="申请医生"
                align="center"
                class="table-column"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="createTime"
                label="申请时间"
                :formatter="formatUnix"
                align="center"
                width="60"
                class="table-column">
        </el-table-column>
        <el-table-column
                prop="consultGroupType"
                label="申请类型"
                align="center"
                width="100">
        </el-table-column>
        <el-table-column
                prop="hopeHosName"
                label="会诊机构"
                align="center"
                class="table-column"
                width="75">
        </el-table-column>
        <el-table-column
                prop="hopeDeptName"
                label="会诊科室"
                align="center"
                class="table-column"
                width="80">
        </el-table-column>
        <el-table-column
                prop="hopeDocName"
                label="会诊医生"
                align="center"
                width="60"
                class="table-column"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="operation"
                label=" 操作"
                align="center"
                inline-template
                class="table-column"
                width="180">
            <div class="table-btn-wrap">
                <el-button
                        size="small"
                        @click="linkToView($index,row)"
                        class="table-btn ghost-btn">
                        会诊单
                </el-button>
                <el-button
                        size="small"
                        type="primary"
                        @click="linkToDeal($index, row)"
                        class="table-btn operate">
                    处理
                </el-button>
            </div>
        </el-table-column>
    </el-table>
</template>
<style>

</style>
<script>
    import { formatUnixTime } from "../../utils/DateFormat.js"
    import axiosUtil from "../../utils/AxiosUtils.js"
    export default{
        props: ["propsTableData"],
        components:{
        },
        methods: {
            formatUnix: function(row, column){//格式化时间格式
                return formatUnixTime(row.createTime, "MM-dd HH:mm");
            },
            sexSelect: function(row, column){//根据服务器获取到的M或者其他显示男或女
                return (row.consulterGender =="M"?"男":"女");
            },
            linkToView: function($index, row){
                //this.$router.push("remoteConsultation/sheet");
                this.$router.push({ name: "printRemoteSheet", params: { consultId: row.consultId ,printDetail:row}})
//                this.$router.push({ name: "remoteSheet", params: { consultId: row.consultId }} );
            },
            linkToDeal: function($index, row){
                //this.$router.push({ name: "remoteToDeal", params: { consultId: row.consultId }} );
                let _this = this;
                let options = {
                    consultId: row.consultId,
                    token: localStorage.getItem("token"),
                    Service: "smarthos.consult.group.ass.grab"
                };
                axiosUtil(options, function(data){
                    _this.$store.dispatch("getCurrentPosition", "ychz_dcl");// 更改侧边栏列表获取数据
                    _this.$store.dispatch("getSideBarTitle", "待处理(我的)");
                    _this.$router.push({ name: "remoteEntry", params: { consultId: row.consultId }} );
                });
            }
        },

    }
</script>
